export default [{
  path: '/data/top-lists',
  name: 'Top List',
  component: () => import('@/views/admin/top-lists/Index.vue'),
  meta: {
    rule: 'editor',
    pageTitle: 'Top List',
    breadcrumb: [{
        title: 'Home',
        url: '/'
      },
      {
        title: 'Data'
      },
      {
        title: 'Top List',
        active: true
      },
    ],
  }
}]
